//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../api/common'
export default {
    created(){
        document.title = '查看医生公告';
        this.$isLogin(window.location.search.substr(1),this.inits);
    },
    data(){
        return {
            details: {}
        }
    },
    methods: {
        inits(){
            var url = window.location.search.substr(1);
            if(this.$route.query.data == null){
                var id = common.getQueryString(url,'id');
                this.$doRequest('/api/doctornotice/getById?id='+id,null,res=>{
                    res.parameters.year = new Date(res.parameters.updatetime).getFullYear();
                    res.parameters.month = new Date(res.parameters.updatetime).getMonth()+1;
                    res.parameters.day = new Date(res.parameters.updatetime).getDate();
                    res.parameters.time = common.timestampToTime(res.parameters.updatetime,3);
                    this.details = res.parameters;
                })
            }else{
                this.details = this.$route.query.data;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/noticeDetails/index.vue